import styled, {css} from "styled-components";
import Colors from "constants/Colors";
import PropTypes from "prop-types";
import {QuicksandBold} from "components/Text/Text";
import {Breakpoints} from "constants/Breakpoints";

const propTypes = {
  isActive: PropTypes.bool,
  newBorder: PropTypes.bool,
};

const defaultProps = {
  isActive: false,
  newBorder: false,
};

const IconButtons = styled.div`
  display: flex;
  align-items:center;
  margin: 1%;
  width: 31.3%;
  height: 30%;
  flex-direction: column;
  cursor: pointer;
  ${({selected}) => selected && css `
    background: #F0F0F0d5;
  `}
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;
`;

const ButtonContent = styled.div`
  display:flex;
  flex-direction:auto;
  justify-content:space-evenly;
  background-color:#FFF;  
`;

export const SelectField = styled.select`
  width: 100%;
  position: relative;
  height: 42px;
  padding: 8px;
  border: solid 1px ${Colors.GRAY[3]};
  border-radius: 8px;
  background: white;
  font-size: 16px;
  color: ${Colors.GRAY[1]};
  outline: none;
  align-self: auto;
  box-sizing: border-box;
  text-align: initial;
  margin-bottom: 20px;
  ${QuicksandBold}

  transition: background 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: ${Colors.GRAY[3]};
  }

  &[disabled] {
    background-color: ${Colors.GRAY[4]};
    color: ${Colors.GRAY[0]};
  }
`;

const LayoutCircle = styled.div`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
  text-align: center;

  align-self: center;

  ${({isActive}) =>
  isActive
    ? css`
      border: 1px solid ${Colors.GRAY[5]};
      background-color: ${Colors.GREEN};
      color: ${Colors.WHITE}
      box-shadow: 0px 3px 4px -2px rgba(0,0,0,0.75);
    `
    : ` border: 1px solid ${Colors.GREEN};
      background-color: ${Colors.WHITE};
      color: ${Colors.BLACK};
    `}
`;

/* &::disabled {
  background-color: ${Colors.GRAY[4]};
  color: ${Colors.GRAY[0]};
} */

export {
  ButtonContent,
  IconButtons
};
